import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Panic }        from '../../shared/entities/panic';
import { Observable }     from '../../../node_modules/rxjs/Observable';

import { SERVER_URL } from './server-url';

@Injectable()
export class PanicService {
    private panicUrl = SERVER_URL + '/api/panics';  // URL to web API
    //private panicUrl = 'http://104.198.40.29:3005/api/panics';  // URL to web API
    //private panicUrl = 'http://localhost:3005/api/panics';  // URL to web API

    constructor (private http: Http) {}

    getAllPanics(tokenLogged:string): Observable<Panic[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.panicUrl, {headers: headers})
                    .map(this.extractPanicsFromJSON)
                    .catch(this.handleError);
    }

    getAllPanicsActive(tokenLogged:string): Observable<Panic[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //headers.append('user', username);
        
        return this.http.get(this.panicUrl + '/active', {headers : headers})
                    .map(this.extractPanicsFromJSON)
                    .catch(this.handleError);
    }

    finishPanic(tokenLogged:string, panic:Panic) {
        let headers = new Headers();
        //console.log('TOKEN => ' + tokenLogged);
        headers.append('Authorization', 'JWT ' + tokenLogged);

        return this.http.post(this.panicUrl + '/' + panic.id + '/finish', null, {headers : headers})
                    .map(this.resultFinishPanic)
                    .catch(this.handleError);
    }

    private resultFinishPanic(res: Response | any) {
        let body = res.json();
       // console.log('CHEGOU ISSO ' + JSON.stringify(res.json()));
        return body;
    }

    private extractPanicsFromJSON(res: Response | any) { 
        let body = res.json();
        var panicList:Panic[] = [];

        for (let entry of body) {
            var panic:Panic = new Panic(entry.id, entry.tracker_id, entry.data_inicial, entry.status, entry.data_recebido, entry.data_final, entry.panic_raw, entry.ativo);
            panicList.push(panic);
        }
        return panicList;
    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/panic.service.ts